import React, { useState, useMemo } from 'react';
import { FaSearch } from 'react-icons/fa';
import PRODUCTS from '../data/products';
import FacetFilter from '../components/FacetFilter/FacetFilter';
import ProductList from '../components/ProductList/ProductList';
import './Catalog.css';

const FACETS = [
  {
    name: 'Brand',
    options: [...new Set(PRODUCTS.map((p) => p.brand))],
  },
  {
    name: 'Category',
    options: [...new Set(PRODUCTS.map((p) => p.category))],
  },
  {
    name: 'Price Range',
    options: ['<1000', '1000-1500', '>1500'],
  },
];

export default function Catalog({ onAddToCart }) {
  const [filters, setFilters] = useState({
    Brand: [],
    Category: [],
    'Price Range': [],
  });
  const [searchTerm, setSearchTerm] = useState('');

  const filteredProducts = useMemo(() => {
    return PRODUCTS.filter((p) =>
      p.name.toLowerCase().includes(searchTerm.toLowerCase())
    ).filter((p) => {
      if (filters.Brand.length && !filters.Brand.includes(p.brand)) {
        return false;
      }
      if (filters.Category.length && !filters.Category.includes(p.category)) {
        return false;
      }
      if (filters['Price Range'].length) {
        const ok = filters['Price Range'].some((r) => {
          if (r === '<1000') {
            return p.price < 1000;
          }
          if (r === '1000-1500') {
            return p.price >= 1000 && p.price <= 1500;
          }
          if (r === '>1500') {
            return p.price > 1500;
          }
          return true;
        });
        if (!ok) {
          return false;
        }
      }
      return true;
    });
  }, [filters, searchTerm]);

  return (
    <div className="page catalog-page">
      <h1>Product Catalog</h1>

      <div className="catalog-controls">
        <div className="search-box">
          <FaSearch className="search-icon" />
          <input
            type="search"
            placeholder="Search products..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <FacetFilter facets={FACETS} onChange={setFilters} />
      </div>

      <ProductList products={filteredProducts} onAddToCart={onAddToCart} />
    </div>
  );
}
